module.exports = __webpack_public_path__ + "static/media/workingmemory-words-3.d65eb996.mp3";